fx.ns("filters", class LayoutProductFilter extends fx.Filter {

	constructor(product, search = "", type)
	{
        super();
        this._product = product;
        this._search = search === undefined ? 1 : search;
        this._type = type || "cover"; // "cover" / "page"
    }

    get product()
    {
        return this._product;
    }

    get search()
    {
        return this._search;
    }

    set search(val)
    {
        if (this._search == val)
            return;

        this._search = val;
        this._changed = true;
        this.trigger("updated");
    }

    get type()
    {
        return this._type;
    }

    set type(val)
    {
        this._type = val;
        this._changed = true;
        this.trigger("updated");
    }
    

	exec()
	{
        if (!this.rawData)
            return;

        this.transformedData = [];
        
        let rawData = this.rawData;
        if (this.type == "page")
            rawData.sort( (a,b) => a.num_photos - b.num_photos);

        for (let i = 0; i < this.rawData.length; i++)
        {
            let layout = this.rawData.getItemAt(i);
        
            if (this.type == "cover")
            {
                if ( layout.product_id == this.product.id && layout.target == "cover")
                    this.transformedData.push( layout );
            }
            else
            {
                if (this.search == "" && this.type == "page")
                {
                    if (layout.product_id != 0 && layout.target == "page")
                        this.transformedData.push( layout );
                }
                else
                if (layout.themeid == -1 && !layout.accountid && layout.target != "cover" && layout.product_id == 0)
                {
                    if (this.search == "all")
                    {
                        if ( layout.num_photos >= 1)
                            this.transformedData.push( layout );
                    }
                    else
                    if (this.search == 1)
                    {
                        if ( layout.num_photos <= 1)
                            this.transformedData.push( layout );
                    }
                    else
                    if (this.search == "+")
                    {
                        if ( layout.num_photos > 4)
                            this.transformedData.push( layout );
                    }
                    else
                    if (this.search > 1 && this.search != "+")
                    {
                    
                        if ( layout.num_photos == this._search)
                            this.transformedData.push( layout );
                    }
                    else
                        this.transformedData.push( layout );

                }

            }
            
        }

        // the covers naming where the photos were taken first, the most precise place leading
        // (LayoutsRepository.matchPlaceCovers), the others in their own order
        if (this.type == "cover" && this.rawData.placeRank)
        {
            let rank = (layout) => { let r = this.rawData.placeRank(layout); return r === undefined ? Infinity : r; };
            let order = this.transformedData.slice();

            this.transformedData.sort((a, b) => (rank(a) - rank(b)) || (order.indexOf(a) - order.indexOf(b)));
        }

        return this.transformedData;
	}	

});